import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';

class Charges extends Component {
  render() {
    return this.props.charges.map((c, i) => {
      return (
        <div key={i}>
          <Row>
            <Col lg={6}>
              <article className='results-component order-info mt-3 mb-5'>
                <ListGroup variant='flush'>
                  <h5 className='ml-3 mb-4 mt-3'>Charge</h5>
                  <ListGroup.Item>
                    Charge:
                    <span className='pl-2'>{c.chargeDescription}</span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Charge Type:
                    <span className='pl-2'>
                      {c.chargeType}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Disposition:
                    <span className='pl-2'>
                      {c.disposition}
                    </span>
                  </ListGroup.Item>
                </ListGroup>
              </article>
            </Col>
            <Col lg={6}>
              <article className='results-component subject-info mt-3 mb-5'>
                <ListGroup variant='flush'>
                  <h5 className='ml-3 mb-4 mt-3'>Sentencing</h5>
                  <ListGroup.Item>
                    Jail Time:
                    <span className='pl-2'>
                      {c.sentence.hasJail ? (
                        <>
                          {c.sentence.jailYears > 0 &&
                            `${c.sentence.jailYears} ${c.sentence.jailYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.jailMonths > 0 &&
                            `${c.sentence.jailYears > 0 ? ', ' : ''}${c.sentence.jailMonths} ${c.sentence.jailMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.jailDays > 0 &&
                            `${(c.sentence.jailYears > 0 || c.sentence.jailMonths > 0) ? ', ' : ''}${c.sentence.jailDays} ${c.sentence.jailDays === 1 ? 'day' : 'days'}`}
                          {c.sentence.jailHours > 0 &&
                            `${(c.sentence.jailYears > 0 || c.sentence.jailMonths > 0 || c.sentence.jailDays > 0) ? ', ' : ''}${c.sentence.jailHours} ${c.sentence.jailHours === 1 ? 'hour' : 'hours'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Jail Suspended:
                    <span className='pl-2'>
                      {c.sentence.hasJailSuspended ? (
                        <>
                          {c.sentence.jailSuspendedYears > 0 &&
                            `${c.sentence.jailSuspendedYears} ${c.sentence.jailSuspendedYears === 1 ? 'year' : 'years'}`}

                          {c.sentence.jailSuspendedMonths > 0 &&
                            `${c.sentence.jailSuspendedYears > 0 ? ', ' : ''}${c.sentence.jailSuspendedMonths} ${c.sentence.jailSuspendedMonths === 1 ? 'month' : 'months'}`}

                          {c.sentence.jailSuspendedDays > 0 &&
                            `${(c.sentence.jailSuspendedYears > 0 || c.sentence.jailSuspendedMonths > 0) ? ', ' : ''}${c.sentence.jailSuspendedDays} ${c.sentence.jailSuspendedDays === 1 ? 'day' : 'days'}`}

                          {c.sentence.jailSuspendedHours > 0 &&
                            `${(c.sentence.jailSuspendedYears > 0 || c.sentence.jailSuspendedMonths > 0 || c.sentence.jailSuspendedDays > 0) ? ', ' : ''}${c.sentence.jailSuspendedHours} ${c.sentence.jailSuspendedHours === 1 ? 'hour' : 'hours'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Prison Time:
                    <span className='pl-2'>
                      {c.sentence.hasPrison ? (
                        <>
                          {c.sentence.prisonYears > 0 &&
                            `${c.sentence.prisonYears} ${c.sentence.prisonYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.prisonMonths > 0 &&
                            `${c.sentence.prisonYears > 0 ? ', ' : ''}${c.sentence.prisonMonths} ${c.sentence.prisonMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.prisonDays > 0 &&
                            `${(c.sentence.prisonYears > 0 || c.sentence.prisonMonths > 0) ? ', ' : ''}${c.sentence.prisonDays} ${c.sentence.prisonDays === 1 ? 'day' : 'days'}`}
                          {c.sentence.prisonHours > 0 &&
                            `${(c.sentence.prisonYears > 0 || c.sentence.prisonMonths > 0 || c.sentence.prisonDays > 0) ? ', ' : ''}${c.sentence.prisonHours} ${c.sentence.prisonHours === 1 ? 'hour' : 'hours'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Prison Suspended:
                    <span className='pl-2'>
                      {c.sentence.hasPrisonSuspended ? (
                        <>
                          {c.sentence.prisonSuspendedYears > 0 &&
                            `${c.sentence.prisonSuspendedYears} ${c.sentence.prisonSuspendedYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.prisonSuspendedMonths > 0 &&
                            `${c.sentence.prisonSuspendedYears > 0 ? ', ' : ''}${c.sentence.prisonSuspendedMonths} ${c.sentence.prisonSuspendedMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.prisonSuspendedDays > 0 &&
                            `${(c.sentence.prisonSuspendedYears > 0 || c.sentence.prisonSuspendedMonths > 0) ? ', ' : ''}${c.sentence.prisonSuspendedDays} ${c.sentence.prisonSuspendedDays === 1 ? 'day' : 'days'}`}
                          {c.sentence.prisonSuspendedHours > 0 &&
                            `${(c.sentence.prisonSuspendedYears > 0 || c.sentence.prisonSuspendedMonths > 0 || c.sentence.prisonSuspendedDays > 0) ? ', ' : ''}${c.sentence.prisonSuspendedHours} ${c.sentence.prisonSuspendedHours === 1 ? 'hour' : 'hours'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Community Service:
                    <span className='pl-2'>
                      {c.sentence.hasCommunityService ? (
                        <>
                          {c.sentence.communityServiceHours > 0 &&
                            `${c.sentence.communityServiceHours} ${c.sentence.communityServiceHours === 1 ? 'hour' : 'hours'}`}

                          {c.sentence.communityServiceDays > 0 &&
                            `${c.sentence.communityServiceHours > 0 ? ', ' : ''}${c.sentence.communityServiceDays} ${c.sentence.communityServiceDays === 1 ? 'day' : 'days'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Driving License Suspension:
                    <span className='pl-2'>
                      {c.sentence.hasDriverLicenseSuspension ? (
                        <>
                          {c.sentence.driverLicenseSuspensionYears > 0 &&
                            `${c.sentence.driverLicenseSuspensionYears} ${c.sentence.driverLicenseSuspensionYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.driverLicenseSuspensionMonths > 0 &&
                            `${c.sentence.driverLicenseSuspensionYears > 0 ? ', ' : ''}${c.sentence.driverLicenseSuspensionMonths} ${c.sentence.driverLicenseSuspensionMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.driverLicenseSuspensionDays > 0 &&
                            `${(c.sentence.driverLicenseSuspensionYears > 0 || c.sentence.driverLicenseSuspensionMonths > 0) ? ', ' : ''}${c.sentence.driverLicenseSuspensionDays} ${c.sentence.driverLicenseSuspensionDays === 1 ? 'day' : 'days'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Credit for Time Served:
                    <span className='pl-2'>
                      {c.sentence.hasCreditForTimeServed ? (
                        <>
                          {c.sentence.creditForTimeServedYears > 0 &&
                            `${c.sentence.creditForTimeServedYears} ${c.sentence.creditForTimeServedYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.creditForTimeServedMonths > 0 &&
                            `${c.sentence.creditForTimeServedYears > 0 ? ', ' : ''}${c.sentence.creditForTimeServedMonths} ${c.sentence.creditForTimeServedMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.creditForTimeServedDays > 0 &&
                            `${(c.sentence.creditForTimeServedYears > 0 || c.sentence.creditForTimeServedMonths > 0) ? ', ' : ''}${c.sentence.creditForTimeServedDays} ${c.sentence.creditForTimeServedDays === 1 ? 'day' : 'days'}`}
                          {c.sentence.creditForTimeServedHours > 0 &&
                            `${(c.sentence.creditForTimeServedYears > 0 || c.sentence.creditForTimeServedMonths > 0 || c.sentence.creditForTimeServedDays > 0) ? ', ' : ''}${c.sentence.creditForTimeServedHours} ${c.sentence.creditForTimeServedHours === 1 ? 'hour' : 'hours'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Probation:
                    <span className='pl-2'>
                      {c.sentence.hasProbation ? (
                        <>
                          {c.sentence.probationYears > 0 &&
                            `${c.sentence.probationYears} ${c.sentence.probationYears === 1 ? 'year' : 'years'}`}
                          {c.sentence.probationMonths > 0 &&
                            `${c.sentence.probationYears > 0 ? ', ' : ''}${c.sentence.probationMonths} ${c.sentence.probationMonths === 1 ? 'month' : 'months'}`}
                          {c.sentence.probationDays > 0 &&
                            `${(c.sentence.probationYears > 0 || c.sentence.probationMonths > 0) ? ', ' : ''}${c.sentence.probationDays} ${c.sentence.probationDays === 1 ? 'day' : 'days'}`}
                        </>
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Fines:
                    <span className='pl-2'>
                      {c.sentence.fine ? (
                        `$${c.sentence.fine.toLocaleString()}.00`
                      ) : "No"}
                    </span>
                  </ListGroup.Item>
                  {/* Fee Component */}
                  <ListGroup.Item>
                    Fee:
                    <span className='pl-2'>
                      {c.sentence.isFeeUnspecified ? "UNSPECIFIED" : (
                        c.sentence.fee !== undefined && c.sentence.fee !== null ?
                          `$${c.sentence.fee.toFixed(2)}` :
                          "No"
                      )}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Restitution:
                    <span className='pl-2'>
                      {c.sentence.isRestitutionUnspecified ? "UNSPECIFIED" : (
                        c.sentence.restitution !== undefined && c.sentence.restitution !== null ?
                          `$${c.sentence.restitution.toFixed(2)}` :
                          "No"
                      )}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Cost:
                    <span className='pl-2'>
                      {c.sentence.isCostUnspecified ? "UNSPECIFIED" : (
                        c.sentence.cost !== undefined && c.sentence.cost !== null ?
                          `$${c.sentence.cost.toFixed(2)}` :
                          "No"
                      )}
                    </span>
                  </ListGroup.Item>
                  {c.sentence.sentencingInfo && <ListGroup.Item>
                    Summary:
                    <span className='pl-2'>{c.sentence.sentencingInfo}</span>
                  </ListGroup.Item>}
                </ListGroup>
              </article>
            </Col>
          </Row>
        </div>
      );
    });
  }
}

export default Charges;
